<template>
  <v-app id="app">
    <v-main>
      <router-view/>
    </v-main>
  </v-app>
</template>
<style>
  @import 'material_icons/material-icons.css';
</style>
<style>
.blue_corp{
  background-color: #042955
}
.orange_corp{
  background-color: #fe6501
}
</style>
<script>
export default {
  name: 'App'
}
</script>